import { ErrorIcon } from '@/components/icons/ErrorIcon';
import { Button } from '@/components/ui/button';
import { useNavigate } from '@tanstack/react-router';
import { useLingui, Trans } from '@lingui/react/macro';

export type ErrorPageProps = {
	title?: string;
	image?: React.ReactNode;
	message?: string;
	buttonText?: React.ReactNode;
	buttonHandler?: () => void;
};
const ErrorPage = ({ buttonHandler, buttonText, title }: ErrorPageProps) => {
	const navigate = useNavigate();
	const { t } = useLingui();

	return (
		<div className="h-full flex justify-center items-center">
			<div className="px-4 w-full flex flex-col gap-9 items-center">
				<ErrorIcon />
				<div className="text-center flex flex-col gap-2">
					<div className="text-2xl font-bold text-foreground text-center">{title || t`Something went wrong`}</div>
					<div className="text-base text-muted-foreground text-center">
						<Trans>
							Sorry, the page you’re looking for doesn’t exist. If you think something is broken, report a problem.
						</Trans>
					</div>
				</div>
				<Button
					size="lg"
					onClick={() => {
						if (buttonHandler) {
							buttonHandler();
						} else {
							navigate({ to: '/signup' });
						}
					}}
				>
					{buttonText || t`Signup`}
				</Button>
			</div>
		</div>
	);
};

export default ErrorPage;
